import { useState } from 'react';
import { Platform } from 'react-native';

// Touch devices always expose actions. Only Mac messages need hover reveal.
export default function useNativeMessageActions() {
  const [isHovered, setIsHovered] = useState(false);
  const isMac = Platform.OS === 'macos';
  return {
    actionsVisible: !isMac || isHovered,
    hoverProps: isMac ? {
      onHoverIn: () => setIsHovered(true),
      onHoverOut: () => setIsHovered(false),
    } : {},
  };
}
